import { render } from "./list.vue?vue&type=template&id=ed7a37ce&ts=true"
import script from "./list.vue?vue&type=script&lang=ts&config=true"
export * from "./list.vue?vue&type=script&lang=ts&config=true"

import "./list.vue?vue&type=style&index=0&id=ed7a37ce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__